package eu.codlab.weather.common.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class WeatherConditionAlertType {
    @SerialName("thunderstorm")
    Thunderstorm,

    @SerialName("drizzle")
    Drizzle,

    @SerialName("rain")
    Rain,

    @SerialName("snow")
    Snow,

    @SerialName("mist")
    Mist,

    @SerialName("smoke")
    Smoke,

    @SerialName("haze")
    Haze,

    @SerialName("sandstorm")
    Sandstorm,

    @SerialName("fog")
    Fog,

    @SerialName("dust")
    Dust,

    @SerialName("ash")
    Ash,

    @SerialName("squall")
    Squall,

    @SerialName("tornado")
    Tornado
}
